<template>
    <v-dialog v-model="dialog" max-width="550">
      <v-card>
        <v-card-text style="padding:0;">

          <v-text-field solo reverse disabled v-model="topDisplay" class="noHeight"></v-text-field>
          <v-text-field solo reverse disabled v-model="bottomDisplay"></v-text-field>

          <v-container grid-list-xs style="padding: 4px 22px 4px 4px;">
            <v-layout row wrap>
             
              <!--First Row-->
              <v-flex xs3>
                <v-btn @click="bottomDisplay = 0">CE</v-btn>
              </v-flex>
              <v-flex xs3>
                <v-btn @click="bottomDisplay = 0; topDisplay = 0;">C</v-btn>
              </v-flex>
              <v-flex xs3>
                <v-btn>
                  back
                </v-btn>
              </v-flex>
              <v-flex xs3>
                <v-btn @click="updateTopDisplay('/')">/</v-btn>
              </v-flex>

              <!--Second Row-->
              <v-flex xs3>
                <v-btn @click="updateBottomDisplay('7')">7</v-btn>
              </v-flex>
              <v-flex xs3>
                <v-btn @click="updateBottomDisplay('8')">8</v-btn>
              </v-flex>
              <v-flex xs3>
                <v-btn @click="updateBottomDisplay('9')">9</v-btn>
              </v-flex>
              <v-flex xs3>
                <v-btn @click="updateTopDisplay('*')">x</v-btn>
              </v-flex>

              <!--Third Row-->
              <v-flex xs3>
                <v-btn @click="updateBottomDisplay('4')">4</v-btn>
              </v-flex>
              <v-flex xs3>
                <v-btn @click="updateBottomDisplay('5')">5</v-btn>
              </v-flex>
              <v-flex xs3>
                <v-btn @click="updateBottomDisplay('6')">6</v-btn>
              </v-flex>
              <v-flex xs3>
                <v-btn @click="updateTopDisplay('-')">-</v-btn>
              </v-flex>

              <!--Fourth Row-->
              <v-flex xs3>
                <v-btn @click="updateBottomDisplay('1')">1</v-btn>
              </v-flex>
              <v-flex xs3>
                <v-btn @click="updateBottomDisplay('2')">2</v-btn>
              </v-flex>
              <v-flex xs3>
                <v-btn @click="updateBottomDisplay('3')">3</v-btn>
              </v-flex>
              <v-flex xs3>
                <v-btn @click="updateTopDisplay('+')">+</v-btn>
              </v-flex>

              <!--Fifth Row-->
              <v-flex xs3>
                <v-btn @click="updateBottomDisplay('0')">0</v-btn>
              </v-flex>
              <v-flex xs3>
                <v-btn @click="updateBottomDisplay('.')">.</v-btn>
              </v-flex>
              <v-flex xs3>
                <v-btn @click="evaluateCalculation()">=</v-btn>
              </v-flex>
              <v-flex xs3>
                <v-btn>accept</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
  </v-dialog>
</template>

<script>
  export default {
    data() {
      return {
        dialog: false,
        topDisplay: '',
        bottomDisplay: 0,
        topDisplayReset: false,
        bottomDisplayReset: false
      }
    },
    methods: {
      updateBottomDisplay(num) {
        if (this.bottomDisplay === 0 || this.bottomDisplayReset) { this.bottomDisplay = '' }
        this.bottomDisplayReset = false

        this.bottomDisplay += num
      },
      updateTopDisplay(num) {
        if (this.topDisplay === 0 || this.topDisplayReset) { this.topDisplay = '' }
        this.topDisplayReset = false

        this.adjustTopDisplay()

        this.topDisplay += num
        this.topDisplay += ' '
        this.bottomDisplayReset = true
      },
      adjustTopDisplay() {
        this.topDisplay += this.bottomDisplay
        this.topDisplay += ' '
      },
      evaluateCalculation() {
        if (!this.topDisplayReset) {
          this.adjustTopDisplay()

          this.bottomDisplay = eval(this.topDisplay)

          this.topDisplayReset = true
          this.bottomDisplayReset = true
        }
      }
    }
  }
</script>


<style scoped>
  .v-btn {
    width: 100%;
  }

  .v-text-field.v-text-field--solo .v-input__control {
    height: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/reuseable/moneyCalculator/MoneyCalculator.vue